import React, { useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiPresetCards from "../../shared/Popup/AiPresetCards";
import { presetTip } from "../../shared/Popup/presetTip";

const STYLES = [
  {
    id: "natural",
    label: "Natural",
    sub: "Recommended",
    tip: presetTip('Natural — "Recommended"', [
      "Realistic colors close to real life",
      "Best default for portraits and everyday scenes",
    ]),
  },
  {
    id: "vivid",
    label: "Vivid",
    sub: "Punchy",
    tip: presetTip('Vivid — "Punchy"', [
      "Richer saturation and contrast",
      "Good for landscapes and product shots",
    ]),
  },
  {
    id: "vintage",
    label: "Vintage",
    sub: "Period look",
    tip: presetTip('Vintage — "Period look"', [
      "Warmer, film-inspired tones",
      "Suits classic and historical photos",
    ]),
  },
];

/**
 * AI Tools → AI Image Colorizer prep.
 */
const ColorizerToolPrep = (props) => {
  const [styleId, setStyleId] = useState("natural");
  const [prompt, setPrompt] = useState("");

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_colorizer"
      title="AI Image Colorizer"
      aka="B&W Colorizer"
      bio="Bring black-and-white photos to life with natural color."
      emptyPreviewLabel="Upload a B&W image to preview colorization"
      loadingLabel="Colorizing…"
      emptyFooterHint="Upload an image, pick a color style, then generate."
      renderControls={({ busy, leftPanelRef }) => (
        <>
          <div className="aftp-section">
            <p className="aftp-label">Color style</p>
            <AiPresetCards
              presets={STYLES}
              selectedId={styleId}
              ariaLabel="Colorizer style"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setStyleId(id);
              }}
            />
          </div>
          <div className="aftp-section">
            <label className="aftp-label" htmlFor="aftp-cz-prompt">
              Color hints <span className="aftp-optional">(optional)</span>
            </label>
            <textarea
              id="aftp-cz-prompt"
              className="aftp-input"
              rows={3}
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              placeholder="e.g. blue dress, green trees, warm skin tones"
              disabled={busy}
            />
          </div>
        </>
      )}
    />
  );
};

export default ColorizerToolPrep;
